import Cookies from "universal-cookie";

const cookies = new Cookies(null, { path: "/" });
const KEY = "user";
const SESSION_MS = 3 * 60 * 60 * 1000; // 3 hours

/** Save user to cookie (with timestamp + expiry) */
export const createUser = async (user) => {
    if (!user) return;
    const payload = { ...user, time: Date.now() };
    cookies.set(KEY, payload, {
        path: "/",
        sameSite: "Lax",
        expires: new Date(Date.now() + SESSION_MS),
    });
};

/** Read user (no side effects). Returns null if missing or stale. */
export const getUser = async () => {
    const u = cookies.get(KEY);
    if (!u) return null;

    const last = typeof u.time === "number" ? u.time : Date.parse(u.time);
    const fresh = Number.isFinite(last) && last > Date.now() - SESSION_MS;
    if (!fresh) {
        await deleteUser();
        return null;
    }
    return u;
};

/** Remove user cookie */
export const deleteUser = async () => {
    cookies.remove(KEY, { path: "/" });
};
